// -*-mode: rjsx -*-
// REACT
import React, { useState, useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// UTILS
// eslint-disable-next-line
import * as _ from "lodash"
// eslint-disable-next-line
import tinycolor from "tinycolor2"

// MUI
import { makeStyles, withStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import AppBar from "@material-ui/core/AppBar"
import IconButton from "@material-ui/core/IconButton"
import InfoIcon from '@material-ui/icons/InfoOutlined'
import MenuIcon from "@material-ui/icons/Menu"
import UpdateIcon from "@material-ui/icons/Update"
import DriveIcon from '@material-ui/icons/TimeToLeaveRounded';
import SettingsIcon from "@material-ui/icons/Settings"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import Drawer from "@material-ui/core/Drawer"
import DescriptionIcon from '@material-ui/icons/Description'
//import Collapse from "@material-ui/core/Collapse"
import List from "@material-ui/core/List"
import Divider from "@material-ui/core/Divider"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from "@material-ui/core/useMediaQuery"


// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"
//import FlashLogo from "../../static/images/lightning-logo-transparent.png"
//import FlashLogo from "../../static/images/pulseai/pulseai.logo2.png"
import FlashLogo from "../../static/images/pulseai/pulseai.logo2.1.png" // this is 72px high which is scaled with icon
//import FlashLogo from "../../static/images/pulseai/pulseai.logo2.icon.png"
import FlashLogoIcon from "../../static/images/pulseai/pulseai.logo2.icon.1.png"
//import FlashLogoIcon from "../../static/images/pulseai/pulseai.logo2.icon.png"
//import FlashLogo from "../../static/images/pulseai/pulseai.logo4.png"
//import FlashLogo from "../../static/images/pulseai/pulseai.logo1.jpg"
//import FlashLogo from "../../static/images/pulseai/pulseai.logo3.jpg"


// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashTopBar>")

const useDefaultStyles = makeStyles(theme => ({


    header1: {
        // flex: '1 1 100%',
        // backgroundColor: "grey"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        fontWeight: "600",
    },
    
    driveItem: {
        paddingLeft: "8px",
        paddingRight: "8px",
        padding: 0,
        width: "100%",
        margin: "0px",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        paddingLeft: "12px",
        paddingRight: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
        "&:hover": {
            //backgroundColor: "#e8e8e8",
            backgroundColor: "#efefef"
        },
    },

    selectedItem: {
        backgroundColor: "#2d88ff1a" // this is for selected
    },

    hrSeparator: {
        direction: "ltr",
        lineHeight: "1.34",
        background: "#dadde1",
        borderWidth: 0,
        color: "#dadde1",
        height: "1px",
        marginTop: "8px",
        marginBottom: "8px",
        marginLeft: "16px",
        backgroundColor: "#ced0d4",
        marginRight: "16px",
        width: "90%"
    },

    driveMenuDiv: {
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        verticalAlign: "center",
        //height: "56px",
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        flexDirection: "column"
    },
    
    appbarRoot: {
        ...theme.css.appbarRoot,
        // desktop - if more than 600
        [theme.breakpoints.up("md")]: {
            // backgroundColor: theme.palette.primary.dark,
        },
    },

    appbarPlus: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },

    appbarMessageLarge: {
        ...theme.css.appbarMessage,
        fontWeight: "bold",
        margin: 0,
        marginLeft: 20,
        color: "#FFFFFF",
        fontSize: "1.25em"
    },

    appbarMessageSmall: {
        ...theme.css.appbarMessage,
        color: "#FFFFFF",
        margin: 0,
        marginLeft: "10px",
        fontSize: "15px"
    },

    appbarDriveRootLarge: {
        marginLeft: "15%",
        marginRight: "auto"
    },

    appbarDriveRootSmall: {
        margin: 0,
        marginRight: "-30px"
    },

    menuButton: {
        marginRight: theme.spacing(2),
        color: "#FFFFFF",
    },

    drawerList: {
        width: "100%",
        maxWidth: 250,
        //        backgroundColor: theme.palette.background.paper
    },

    nestedItem: {
        paddingLeft: theme.spacing(4),
    },

    updateMenu: {
        fontWeight: "bold",
    },
    
    settingsMenu: {
//        fontSize: "0.875rem",
//        fontWeight: "bold",
        fontFamily: "\"Roboto\",\"Helvetica\", \"Arial\", sans-serif"

        // Arial,"Helvetica Neue",Helvetica,sans-serif;
        
    },

    screenSize: {
        isLarge: false,
        [theme.breakpoints.up("md")]: {
            isLarge: true
        }
    },

}), { name: "FlashTopBar" })


const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        marginTop: "0px",
        marginLeft: "-2px",
        width: "310px",
        backgroundColor: "white",
        color: "black",
        borderRadius: "8px",
        boxShadow: "0 12px 28px 0 rgba(52, 73, 94, .2), 0 2px 4px 0 rgba(52, 73, 94, .2), inset 0 0 0 1px rgba(52, 73, 94, .2) ",

        // actual insides
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: theme.typography.pxToRem(12),
        paddingBottom: "8px",
        paddingLeft: "8px",
        paddingRight: "8px",
        paddingTop: "8px",
    },
    tooltipPlacementLeft: {
    },
    arrow: {
        color: "white",
        width: "12px",
        height: "12px",
    },
    
    // yes, this works!!!
    popperArrow: {
        '&[x-placement*="bottom"] .MuiTooltip-arrow': {
            top: "0",
            left: "0",
            //            marginTop: "-0.71em",
            // marginTop: "0!important",            yeah, it works
            marginTop: "-10px",
            marginLeft: "15px",
            marginRight: "12px",
            width: "16px",
        }
    }

}))(Tooltip)

let FlashTopBar = (props) => {

    // eslint-disable-next-line
    const {
        text,
        variation: _variation,
        drives: _drives,
        onChange
    } = props

    const classes = {
        ...useDefaultStyles(),
    }

    // DEBUG only
    // eslint-disable-next-line
    const [isDebugLayout, setDebugLayout] = useState(false)
    // these 3 states have to be separate not to conflict with
    // each other
    const [state, setState] = useState({
        isDrawerOpen: false,
        isDriveMenuOpen: false
    })
    
    const [redirectState, setRedirect] = useState({
        toRegister: false,
        toVariation: null,
    })

    const [submenuState, setSubmenu] = useState({
        isSettingsOpen: false
    })

    /*
    const [variationState, setVariation] = useState(
        () => {
            // log.trace("<FlashTopBar>: useState(): variation =", variation)
            //if(variation) return variation
            //else return "A"
            // return "A"
            return variation
        }
    )
    */
    const [variation, setVariation] = useState(_variation);

    const [drives, setDrives] = useState(_drives ? _drives : []);

    const isLargeScreen = useMediaQuery('(min-width:600px)');
    log.debug("<FlashTopBar>: isLargeScreen =", isLargeScreen);

    log.trace("<FlashTopBar>: _drives = ", _drives);
    log.trace("<FlashTopBar>: drives = ", drives);
    log.trace("<FlashTopBar>: variation = ", variation);
    
    //
    // hooks first
    //

    useEffect(() => {
        setDrives(_drives)
    },[_drives])

    useEffect(() => {
        //log.trace("<FlashTopBar>: variationState effect redirectSTate = ", redirectState)
        //log.trace("<FlashTopBar>: variationState effect variationState = ", variationState)
        
        //        log.trace("<FlashTopBar>: variationState effect before resetting variation")
//        if(variation.next) {
//            variation.current = variation.next
//            variation.next = null
//        }
        // log.trace("<FlashTopBar>: variationState effect after resetting variaction = ", variationState)

    })

    
//    useEffect(() => {
//        log.trace("<FlashTopBar>: variationState effect variationState = ", variationState)
//        if(variationState.current === variationState.next) {
//            // we are running after the redirection is done so reset
//            setVariation({...variationState, next: null })
//            setRedirect({...redirectState, toVariation: false })
//        }
//    }, [variationState])

    // log.trace("<FlashTopBar>: root state = ", state)
   
    const toggleDrawer = isOpen => event => {
            
        if(event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return
        }
        // log.trace("<FlashTopBar>: toggleDrawer(): setting state = ", state)
        setState({...state, isDrawerOpen: isOpen})
    }

    const toggleDriveMenu = isOpen => event => {
        // debug here, see what's up
            
        if(event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return
        }
        
        log.trace("<FlashTopBar>: toggleDriveMenu(): setting state = ", state)
        if(isOpen !== undefined) {
            setState({...state, isDriveMenuOpen: isOpen})
        } else {
            setState({...state, isDriveMenuOpen: !state.isDriveMenuOpen})
        }
    }
    

    const handleUpdateProfileClick = () => {
        // log.trace("<FlashTopBar>: handleUpdateProfileClick()")
        // log.trace("<FlashTopBar>: toggleDrawer(): setting state = ", state)
        setRedirect({...redirectState, toRegister: true})
    }

    const handleSettingsClick = () => event => {
        event.stopPropagation()
        setSubmenu({...submenuState, isSettingsOpen: !submenuState.isSettingsOpen})
    }

    // eslint-disable-next-line
    const handleVariationClick = variationArg => event => {
        // event.stopPropagation()
        //        setVariation({...variationState, next: variationArg, current: variationArg })
        setVariation({...variation, next: variationArg, current: variationArg })

//        log.trace("handleVariationClick(): variationArg =", variationArg)
//        log.trace("handleVariationClick(): variationState =", variationState)
//        log.trace("handleVariationClick(): variationState.current =", variationState.current)
        
        setRedirect({...redirectState, toVariation: true })
    }

    // log.trace("<FlashTopBar>: before redirection section")
    log.trace("<FlashTopBar>: redirectState = ", redirectState)
    log.trace("<FlashTopBar>: variation = ", variation)
    
    if(redirectState.toRegister) {
        if(props.match) { // this comes up if we go from the dash that does not have a drive yet
            const { driveSlug } = props.match.params
            if(driveSlug) {
                const newUrl = `/drives/${driveSlug}/register`
                return (<Redirect push to={newUrl}/>)
            }
        }
         // const newUrl = `/drives/${newDrive.slug}/register`
        return (<Redirect push to="/register"/>)
    } else if (redirectState.toVariation) {
        // log.trace("<FlashTopBar>: redirecting to variation")
        redirectState.toVariation = false
        log.trace("<FlashTopBar>: redirecting to => ", variation[variation.next])
        return (<Redirect push to={variation[variation.next]}/>)
    }

    // log.trace("<FlashTopBar>: after redirection section")
    // we use style from props to set the root style to this div

    // next: fix when we are on A, going to B

    return (
        <AppBar className={clsx(classes.appbarRoot, classes.appbarPlus)} position="fixed" color="default">
          <div style={{display: "flex", alignItems: "center"}}>

            {/*
            <div style={{display: "inline"}}>
              <img alt="logo" src={FlashLogo} style={{display: "inline", width: 190, marginLeft: 8, marginTop: 5}}/>
            </div>
             */}

            <div style={{display: "inline" }}>
              {isLargeScreen ? (
                  <img alt="logo" src={FlashLogo} style={{display: "inline", width: 190, marginLeft: 8, marginTop: 5}}/>
              ) : (
                  <img alt="logo" src={FlashLogoIcon} style={{display: "inline", height: 72, marginLeft: 10, marginTop: 5}}/>
              )}
              
            </div>

            <div style={{display: "inline"}}>
              <Typography display="inline" variant="h6"
                          className={clsx({
                              [classes.appbarMessageLarge]: true, // default
                              [classes.appbarMessageSmall]: !isLargeScreen
                          })}
              >
                {text}
              </Typography>
         </div>


        {/*
            <div style={{display: "inline"}}>
              <Typography style={{ fontWeight: "bold", marginLeft: 20, color: "#FFFFFF"}} display="inline" variant="h6"
              >
                {text}
              </Typography>
            </div>
         */}

            

          </div>

          {drives &&
          <div className={clsx({
                              [classes.appbarDriveRootLarge]: true, // default
                              [classes.appbarDriveRootSmall]: !isLargeScreen
                          })}>
            <ClickAwayListener onClickAway={toggleDriveMenu(false)}>
              <div style={{display: "flex", alignItems: "center"}}>
                  <HtmlTooltip id="infoTooltip"
                               PopperProps={{
                                   disablePortal: false,
                                   strategy: "fixed",
                                   placement: "bottom-start",
                                   modifiers: 
                                       {
                                           flip: {
                                               // behavior: ['left', 'right', 'top','bottom']
                                               // behavior: ['top']
                                               enabled: false // yes, this works!, need to be using 1.x
                                           },
                                           arrow: {
                                           }
                                       },

                               }}
                               arrow // yes, this works, but make it like we have for the chart tooltip
                               // onClose={handleInfoTooltipClose}
                               open={state.isDriveMenuOpen}
                               //disableFocusListener
                               //disableHoverListener
                               //disableTouchListener
                               interactive
                               //disableReactTree={true}
                               title={<React.Fragment>
                                        <div className={classes.driveMenuDiv}>
                                          {(() => {
                                              let rowNumber = 0
                                              if(drives) {
                                                  return drives.map(drive => (
                                                      <span key={drive.slug} style={{width: "100%"}}
                                                            onClick={(event) => {
                                                                toggleDriveMenu()(event)
                                                                onChange({widget: "drive", drive: drive})(event)
                                                            }}>
                                                    {rowNumber++ !== 0 && <hr className={classes.hrSeparator}/>}
                                                    <div className={clsx({
                                                        [classes.driveItem]: true,
                                                        [classes.selectedItem]: drive.isSelected,
                                                    })}>
                                                      <Typography className={classes.header1} variant="h6" id="tableHeader1">
                                                        {drive.txt}
                                                      </Typography>
                                                    </div>
                                                  </span>                                 
                                                  ))
                                              }
                                          })()}
                                        </div>
                                      </React.Fragment>}>
                    <IconButton edge="start"
                                className={classes.menuButton}
                                aria-label="menu"              
                                onClick={toggleDriveMenu()}>
                      <DriveIcon  style={{fontSize: 35}}/>
                    </IconButton>
                  </HtmlTooltip>
           {isLargeScreen &&
                <Typography style={{marginLeft: "-16px", color: "white"}} className={classes.header1} variant="h6" id="tableHeader1">
                  {(() => {
                      if(drives) {
                          const selectedDrive = drives.find(drive => drive.isSelected)
                          if(selectedDrive) {
                              return selectedDrive.txt
                              }
                          }
                          return "..."
                      })()}
            </Typography>
           }
              </div>
            </ClickAwayListener>
        
          </div>
          }
          
          <div>
            <IconButton edge="start"
                        className={classes.menuButton}
                        aria-label="menu"              
                        onClick={toggleDrawer(true)}>
              <MenuIcon  style={{fontSize: 35}}/>
            </IconButton>
          </div>

          <Drawer anchor="right" open={state.isDrawerOpen} onClose={toggleDrawer(false)}>
            <div className={classes.drawerList}
                 role="presentation"
                 onClick={toggleDrawer(false)}
                 onKeyDown={toggleDrawer(false)}>
              <List>
                <ListItem button key={text} onClick={handleUpdateProfileClick}>
                  <ListItemIcon><UpdateIcon/></ListItemIcon>
                  <ListItemText classes = {{ primary: classes.settingsMenu }} primary="Update Profile"/>
                </ListItem>
                <Divider/>
                <ListItem button key={"settings"} onClick={handleSettingsClick()}>
                  <ListItemIcon><SettingsIcon/></ListItemIcon>
                  <ListItemText classes = {{ primary: classes.settingsMenu }} primary="Settings"/>
                  {submenuState.isSettingsOpen ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                </ListItem>
                {/*
                <Collapse in={submenuState.isSettingsOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem button className={classes.nestedItem} selected={variationState.current === "A"}
                              onClick={handleVariationClick("A")}>
                      <ListItemText primary="Variation A" />
                    </ListItem>
                    <ListItem button className={classes.nestedItem} selected={variationState.current === "B"}
                              onClick={handleVariationClick("B")}>
                      <ListItemText primary="Variation B" />
                    </ListItem>
                  </List>
                </Collapse>
                 */}
              </List>
            </div>
          </Drawer>
        </AppBar>
    )
}

export default FlashTopBar

